import React from 'react';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeMode } from '../../theme/ThemeModeContext';

const ThemeModeToggle = () => {
  const { mode, toggleMode } = useThemeMode();
  const { t } = useTranslation();
  const label = mode === 'dark' ? t('theme.switchToLight') : t('theme.switchToDark');

  return (
    <IconButton aria-label={label} onClick={toggleMode} color="inherit">
      {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
    </IconButton>
  );
};

export default ThemeModeToggle;
